/**
* @description: 物料申购
* @author: niuzijie
*/
<template>
  <div class="materialPurchaseContent main-wrap">
    <div class="main-top">
      <el-button type="primary" class="addAddress h40" @click="openDialog" icon="iconfont iconxinzeng">{{ $lang('申购物料') }}
      </el-button>
      <div class="searchParam" id="jmsSearch">
        <el-form :model="searchParam" ref="seach" :inline="true">
          <el-form-item prop="date">
            <el-date-picker
              :clearable="false"
              v-model="searchParam.date"
              type="datetimerange"
              :default-time="['00:00:00', '23:59:59']"
              :range-separator="$lang('至')"
              :start-placeholder="$lang('开始日期')"
              :end-placeholder="$lang('结束日期')"
              class="commonSize"
              @change="selectDate"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item prop="code">
            <base-input-tag
              style="width:230px"
              v-model="searchParam.codes"
              :placeholder="$lang('请输入编号(最多可查200条)')"
              :clearBtnVisible="true"
              :addTagOnBlur="true"
              ref="BaseInputTag1"
              class="cms-input-tag">
            </base-input-tag>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="iconfont iconchaxun" class="h32" @click="searchChange">{{ $lang('查询') }}</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" plain icon="iconfont iconshanchu" class="h32" @click="resetSearch">{{ $lang('清空') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="main-table">
      <JmsTableScroll
        ref="table"
        :option="listOpt"
        :data="tableList"
        :page="page"
        :table-loading="loading"
        @size-change="sizeChange"
        @select-change="selectionChange"
        @current-change="currentChange">
        <template slot="applicationContent" slot-scope="{ row }">
          <span class="detail-btn" @click="viewRow(row)">{{ $lang('查看') }}</span>
        </template>
      </JmsTableScroll>
    </div>
    <!-- 新增 -->
    <AddDialog :dialog-visible.sync="dialogVisible" @searchFun="searchFun" />
    <!-- 详情 -->
    <DetailDialog :viewDialogVisible.sync="viewDialogVisible" :grantDetailList="grantDetailList" :rowCode="rowCode" />
  </div>
</template>

<script>
import JmsTableScroll from '@/components/jms-widget/jms-table-scroll'
import mixin from '@/mixins/mixin.js'
import { commonFun } from '@utils/common'
import AddDialog from './components/add'
import DetailDialog from './components/detail'
import { materialGrantPage } from '@api/module/customer'

export default {
  name: 'MaterialPurchase',
  components: {
    JmsTableScroll,
    AddDialog,
    DetailDialog,
  },
  mixins: [mixin],
  data() {
    let choiceDate = ''
    return {
      COM_HTTP: {
        reqList: materialGrantPage,
      },
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          choiceDate = minDate.getTime()
          if (maxDate) {
            choiceDate = ''
          }
        },
        disabledDate: time => {
          if (choiceDate) {
            const limitRange = 59 * 24 * 3600 * 1000 // 60天范围内可选
            const maxTime = choiceDate + limitRange
            const minTime = choiceDate - limitRange
            return time.getTime() > maxTime || time.getTime() < minTime
          } else {
            return false
          }
        },
      },
      dialogVisible: false,
      viewDialogVisible: false,
      searchParam: {
        date: [commonFun.GetTodayDate(-29)[0], commonFun.GetTodayDate()[1]],
        startTime: commonFun.GetTodayDate(-29)[0],
        endTime: commonFun.GetTodayDate()[1],
        codes: [], // 编号
      },
      grantDetailList: [], // 申购物料明细
      rowCode: '',
    }
  },
  computed: {
    listOpt() {
      const that = this
      return {
        fixHeight: 90,
        selection: false,
        menu: false,
        column: [
          {
            label: '编号', //  扫描员
            prop: 'code',
          },
          {
            label: '状态',
            prop: 'applyStatus',
            formatter: (row) => {
              const map = {
                1: '待处理',
                2: '已完成',
                3: '已作废',
              }
              return that.$lang(map[row.applyStatus])
            }
          },
          {
            label: '申请时间',
            prop: 'createTime',
          },
          {
            label: '申请内容',
            prop: 'applicationContent',
            slot: true,
          },
          {
            label: '付款方式',
            prop: 'payType',
            formatter: (row) => {
              const map = {
                1: '货到付款',
                2: '从COD中扣除',
              }
              return that.$lang(map[row.payType])
            }
          },
          {
            label: '收货人',
            prop: 'consignee',
          },
          {
            label: '收货人手机号',
            prop: 'phone',
          },
          {
            label: '收货地址',
            prop: 'addressDetail',
            formatter: (row) => {
              const { address, area, city, province } = row
              return `${address}/${area}/${city}/${province}`
            }
          },
          {
            label: '备注',
            prop: 'remark',
          },
        ],
      }
    },
  },
  methods: {
    viewRow(row) {
      this.grantDetailList = row.grantDetailList
      this.rowCode = row.code
      this.viewDialogVisible = true
    },
    openDialog() {
      this.dialogVisible = true
    },
    // 触发按钮查询
    searchChange() {
      const { codes } = this.searchParam
      // 处理运单编号
      if (codes && codes.length !== 0) {
        if (codes.length > 200) {
          return this.$message.warning(this.$lang('请勿超过200条编号'))
        }
      }
      this.searchFun(1)
    },
    resetSearch() {
      this.$refs.seach.resetFields()
      this.searchParam = {
        date: [commonFun.GetTodayDate(-29)[0], commonFun.GetTodayDate()[1]],
        startTime: commonFun.GetTodayDate(-29)[0],
        endTime: commonFun.GetTodayDate()[1],
      }
      this.$refs.BaseInputTag1.clearFn()
    },
    // 搜索-获取参数
    getParams() {
      const { date, codes } = this.searchParam
      const startTime = date[0]
      const endTime = date[1]
      return {
        ...this.searchParam,
        startTime: codes.length > 0 ? '' : startTime,
        endTime: codes.length > 0 ? '' : endTime,
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.el-table th.gutter {
  display: table-cell !important;
}

.userManageContent {
  .searchParam {
    // padding: 18px 0;
    margin-top: 10px;
    display: inline-flex;
    width: 100%;
    position: relative;

    .searchParamInput {
      padding-right: 16px;
    }
  }

  .main-top {
    padding: 16px 24px;
  }

  .main-table {
    padding: 12px 24px;
    background: #edeef3;
    flex: 1
  }

  .el-dialog__wrapper {
    .el-dialog {
      .el-dialog__body {
        padding: 0;

        .userTree {
          width: 200px;
          border-right: 1px dashed #eeeeee;
        }

        .myAccount {
          display: inline-flex;
          padding-top: 16px;

          .myAccountItem {
            width: 200px;
            padding: 0 8px;

            .myAccountItemText {
              padding-bottom: 4px;
            }
          }
        }

        .statusSetting {
          //   width: 200px;
          padding: 16px 8px;

          .statusSettingText {
            padding-bottom: 8px;
          }

          .label {
            margin-right: 20px;
            font-size: 16px;
            font-weight: 600
          }
        }

        .require {
          color: red;
        }
      }

      .el-dialog__header {
        padding: 12px 25px !important;
        border-bottom: 1px solid #eeeeee;
      }

      .el-dialog__footer {
        // border-top: 1px solid #eeeeee;
        padding: 8px 24px 16px !important;
      }
    }
  }

  .dot {
    margin-right: 5px;
    width: 6px;
    height: 6px;
    background: #999;
    display: inline-flex;
    vertical-align: middle;
    border-radius: 50%;

    &.yellow {
      background: #ffa111;
    }

    &.green {
      background: #00da00;
    }
  }

  .iconfont {
    font-size: 14px;
  }
}

</style>

<style lang="scss" scoped>
.materialPurchaseContent {
  .searchParam {
    margin-top: 10px;
  }
  .main-top {
    padding: 16px 24px;
  }

  .main-table {
    padding: 12px 24px;
    background: #edeef3;
    flex: 1
  }
}
.detail-btn {
  font-size: 12px;
  font-weight: Medium;
  text-align: left;
  color: #e60000;
  cursor: pointer;
}
</style>
